import { defineComponent, ref } from "vue";
import {ISelectedOrganisation} from "@/app/admin/components/kl-search-organisation/kl-search-organisation";
import {EAlertType} from "@/app/shared/state/AlertModule";
import {IAlertHandler} from "@/plugins/alert";
import {useForm} from 'vee-validate';
import {useKlModalEventsUtil} from '@/app/shared/helpers/kl-modal-events-util';
import * as yup from 'yup';
import {toTypedSchema} from '@vee-validate/yup';
import {
    klValidationFields,
    ValidationFieldsType
} from '@/app/shared/components/kl-form-fields/kl-field-validation-util';

export interface IMapRequestToMove {
    destinationKlipOrganisationId: string;
    destinationParentKlipOrganisationId?: string | undefined;
    reason: string;
}

export class MoveMapRequestNotifications {
    static ShowFailure(alertHandler: IAlertHandler) {
        const toasterId = `move-failed-toaster-${Math.random()
            .toString(36)
            .substring(7)}`;
        const message =
            'Er ging iets mis! Uw planaanvragen zijn NIET in de queue gezet om te verplaatsen. Probeer je even opnieuw?';
        alertHandler.addAlert({
            type: EAlertType.Error,
            id: toasterId,
            title: 'Planaanvragen verplaatsen mislukt',
            message: message,
            icon: 'info-circle',
            autoClose: 5000,
            closable: true,
        });
    }

    static ShowSuccess(alertHandler: IAlertHandler, numberOfMovedMapRequests: number) {
        const toasterId = `move-success-toaster-${Math.random()
            .toString(36)
            .substring(7)}`;
        const message =
            numberOfMovedMapRequests > 1
                ? `Er zijn ${numberOfMovedMapRequests} planaanvragen in de queue gezet om te verplaatsen. U ontvangt een e-mail met het resultaat.`
                : `Er is 1 planaanvraag in de queue gezet om te verplaatsen. U ontvangt een e-mail met het resultaat.`;
        alertHandler.addAlert({
            type: EAlertType.Success,
            id: toasterId,
            title: 'Planaanvragen verplaatsen',
            message: message,
            icon: 'info-circle',
            autoClose: 5000,
            closable: true,
        });
    }
}

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlMoveMapRequest',
    emits: ['move'],
    setup(props, { emit }) {

        const schema = yup.object({
            selectedDestinationOrganisation: yup.object().required().label('Organisatie'),
            reason: yup.string().required().label('Reden van verplaatsing'),
        });

        const modalEvents = useKlModalEventsUtil('move-map-request-modal',
            {
                onClosed: () => _reset(),
            });

        const form = useForm({
            validationSchema: toTypedSchema(schema),
        });
        const fields: ValidationFieldsType<typeof schema> = klValidationFields<typeof schema>(schema);

        const selectedDestinationOrganisation = fields.selectedDestinationOrganisation.getValue<ISelectedOrganisation>();
        const reason = fields.reason.getValue<string>();

        const movingMapRequests = ref<boolean>(false);


        const _reset = () => {
            form.resetForm();
        }

        const onCloseMoveMapRequestModal = () => {
            modalEvents.triggerModalToggle();
        };

        const _move = () => {
            emit('move', <IMapRequestToMove> {
                destinationKlipOrganisationId: selectedDestinationOrganisation.value.organisationId,
                destinationParentKlipOrganisationId: selectedDestinationOrganisation.value.parentId,
                reason: reason.value
            });

            modalEvents.triggerModalToggle();
        }

        const _onInvalidSubmit = (submittedValues) => {
            console.log('_onInvalidSubmit', submittedValues);
        }

        const onSubmit = form.handleSubmit(_move, _onInvalidSubmit);

        return {
            selectedDestinationOrganisation,
            reason,

            movingMapRequests,

            onCloseMoveMapRequestModal,
            onSubmit,

            fields,
        };
    }
});
